import { escapeSingleDoubleQuotesAndBackSlash } from '../edge-server/utils/escapeSingleDoubleQuotesAndBackslash';
import { EQLFunction, ExpressionType } from './types';

export const wrapExpressionType = (
  expressionType: ExpressionType,
  functions?: EQLFunction[],
): string => {
  return (
    functions?.reduce((wrapped: string, fn) => {
      if (!fn.params) {
        return `${fn.name}(${wrapped})`;
      }
      const params = (
        fn.params?.map((param) =>
          typeof param === 'string'
            ? escapeSingleDoubleQuotesAndBackSlash(param)
            : param,
        ) ?? []
      )
        .map((param) => param.toString())
        .join(', ');
      return `${fn.name}(${wrapped}, ${params})`;
    }, expressionType) ?? expressionType
  );
};
